query Brand(
    $id: ID!
) {
    brand(
        id: $id
    ) {
        id

        productLines {
            id

            key
            name {
                language
                text
            }

            position
        }
    }
}
